module.exports = __webpack_public_path__ + "img/interface.b7deb761.svg";